// JsFromRoutes CacheKey 0fcfeae3b61128b766036b12dc7a3c7a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  removeAttachmentFromSubstantiation: /* #__PURE__ */ definePathHelper('post', '/admin/substantiations/:substantiation_id/remove_attachment_from_substantiation'),
  sendReceiptMailer: /* #__PURE__ */ definePathHelper('post', '/admin/substantiations/:substantiation_id/send_receipt_mailer'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/substantiations'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/substantiations/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/substantiations/:id'),
}
